<template>
  <oie-checkout-accordion-block>
    <button class="checkout-section__header" @click="toggleAccordion()">
      {{ header }}

      <div class="checkout-section__toggler">
        <oie-use-svg svg="circle-down" :class="{ 'svg--90-negative': isOpen }"></oie-use-svg>
      </div>
    </button>

    <div class="checkout-section__content" :class="{ 'checkout-section__content--is-open': isOpen }">
      <div class="checkout-actions__form">
        <slot></slot>
      </div>
    </div>
  </oie-checkout-accordion-block>
</template>

<script>
import accordionMixin from '@/mixins/accordion.js'
import httpService from '@/core/http-service'

export default {
  mixins: [accordionMixin],
  props: {
    header: {
      type: String,
      required: true
    }
  },
  methods: {
    submitData(submitType) {
      if(submitType === 'comment') {
        this.addCommentToOrder()
      } else if(submitType === 'code') {
        this.activateCode()
      }
    },
    addCommentToOrder() {
      httpService.post('checkout/addCommentToOrder', { comment: this.textValue })
    },
    activateCode() {
      httpService.post('checkout/activateCode', { activateCode: this.textValue })
    }
  }

}
</script>

<style lang="scss">
.checkout-actions {
  display: flex;
  flex-direction: column;

  @include media(small) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}

.checkout-actions__section {
  width: 100%;
  margin-bottom: 0;

  &:first-child {
    margin-bottom: measure(quarter);

    @include media(small) {
      margin-bottom: 0;
    }
  }

  @include media(small) {
    width: calc(50% - #{measure(quarter)});
  }
}

.checkout-actions__form {
  display: flex;
  flex-direction: column;
  padding: measure(full);
  width: 100%;
}

.checkout-actions__form-description {
  margin-top: 0;
}

.checkout-actions__form > *:not(:last-child) {
  margin-bottom: measure(full);
}
</style>
